export default {
    // copy this file to config.js and edit the settings to match yours
    drupal_url: 'https://license.xecurify.com/drupal',
    //drupal_url: 'http://deepak.miniorange.in/drupal915',
    SsoLink: 'https://license.xecurify.com/drupal/moLogin',
    homeLink: 'https://license.xecurify.com/'

}
